import { createContext, type PropsWithChildren, use } from "react";

import { NoTouchPurchaseModal } from "app/components/no-touch-purchase-modal/NoTouchPurchaseModal";
import { useAddonsState } from "app/contexts/AddonStateContext/AddonStateContext";
import type { AddonTypeName } from "app/contexts/AddonStateContext/const";
import { useNoTouchPurchaseProvider } from "app/contexts/NoTouchPurchaseContext/useNoTouchPurchaseProvider";

export interface INoTouchPurchaseContext {
    handlePurchaseAddonClick: (addonType: AddonTypeName | null, quantity?: number, variation?: string) => void;
    isSmallOneClickModalOn: boolean;
}

const defaultContextValue: INoTouchPurchaseContext = {
    handlePurchaseAddonClick: () => {},
    isSmallOneClickModalOn: false,
};

const NoTouchPurchaseContext = createContext<INoTouchPurchaseContext>(defaultContextValue);

export const NoTouchPurchaseProvider = ({ children }: PropsWithChildren) => {
    const { hasAddonsHub } = useAddonsState();
    const { contextValue, addonType, preselectQuantity, preselectVariation, setAddonType, handlePurchaseAddonClick } =
        useNoTouchPurchaseProvider();

    return (
        <NoTouchPurchaseContext.Provider value={contextValue}>
            {children}

            {hasAddonsHub ? (
                <NoTouchPurchaseModal
                    addonType={addonType}
                    preselectQuantity={preselectQuantity}
                    preselectVariation={preselectVariation}
                    isSmallOneClickModalOn={contextValue.isSmallOneClickModalOn}
                    setAddonType={setAddonType}
                    onPurchaseAddonClick={handlePurchaseAddonClick}
                />
            ) : null}
        </NoTouchPurchaseContext.Provider>
    );
};

export const useNoTouchPurchaseContext = () => use(NoTouchPurchaseContext);
